// Stamina bar — sits just ABOVE the centre bottom HUD bar. Shown while sprinting or while stamina
// is below max (recovering); hidden once full. Driven by the client-side staminaStore.

import { injectTheme } from "./theme.js";
import { staminaStore } from "../items/staminaStore.js";
import { registerBottomSlot, setBottomSlot } from "./bottomStack.js";

const STYLE_ID = "ghostland-stamina-style";
const CSS = `
#gl-stamina {
  position: fixed; left: 50%; bottom: 104px; transform: translateX(-50%); z-index: 25;
  width: 220px; opacity: 0; transition: opacity .25s ease; pointer-events: none;
  font-family: ui-monospace, "SFMono-Regular", Menlo, monospace; user-select: none;
}
#gl-stamina.show { opacity: 1; }
#gl-stamina .bar {
  position: relative; height: 8px; border-radius: 4px; overflow: hidden;
  background: var(--gl-panel-2); box-shadow: inset 0 0 0 1px var(--gl-border);
}
#gl-stamina .fill { position: absolute; inset: 0; width: 100%; transition: width .1s linear;
  background: linear-gradient(#e9d24a, #c8a81f); }
/* drained → reddish so "out of breath" reads at a glance */
#gl-stamina.low .fill { background: linear-gradient(#e07a3a, #b8521f); }
`;

let root: HTMLDivElement | null = null;
let fill: HTMLDivElement | null = null;

/** Mount the stamina bar (idempotent) and wire it to the staminaStore. */
export function mountStaminaHud(): void {
  if (root) return;
  injectTheme();
  if (!document.getElementById(STYLE_ID)) {
    const s = document.createElement("style"); s.id = STYLE_ID; s.textContent = CSS; document.head.appendChild(s);
  }
  root = document.createElement("div");
  root.id = "gl-stamina";
  root.innerHTML = `<div class="bar"><div class="fill"></div></div>`;
  document.body.appendChild(root);
  registerBottomSlot("stamina", root); // top-priority slot: anchored at the base of the bottom stack
  fill = root.querySelector(".fill");
  staminaStore.subscribe(({ current, max, active }) => {
    const pct = max > 0 ? Math.max(0, Math.min(1, current / max)) : 0;
    if (fill) fill.style.width = `${(pct * 100).toFixed(0)}%`;
    // Visible while sprinting or recovering; hidden once topped off.
    const show = active || pct < 0.999;
    root!.classList.toggle("show", show);
    root!.classList.toggle("low", pct < 0.3);
    setBottomSlot("stamina", show);
  });
}
